import {
  createSlice,
  PayloadAction,
} from "@reduxjs/toolkit";

export type OrderSectionType =
  | "rebar"
  | "net"
  | "pile";

export interface OrderSectionHeader {
  id: number | string;
  type: "header";
  sectionType: OrderSectionType;
  title: string;
  supplierNote: string;
  position: number;
  isNew?: boolean;
  isEditing?: boolean;
}

export interface OrderHeaders {
  rebar: OrderSectionHeader[];
  net: OrderSectionHeader[];
  pile: OrderSectionHeader[];
}

export interface OrderState {
  currentOrder: any;
  currentOrderSupplier: any;
  currentOrderHeaders: OrderHeaders;
  showPrice: boolean;
  value: number;
  isDeleted: boolean;
  reqStatus: any;
  orderId: number;
}

const emptyOrderHeaders = (): OrderHeaders => ({
  rebar: [],
  net: [],
  pile: [],
});

const initialState: OrderState = {
  currentOrder: {},
  currentOrderSupplier: null,
  currentOrderHeaders: emptyOrderHeaders(),
  showPrice: false,
  value: 0,
  isDeleted: false,
  reqStatus: null,
  orderId: 0,
};

export const orderSlice = createSlice({
  name: "order",
  initialState,

  reducers: {
    setCurrentOrder: (
      state,
      action: PayloadAction<any>
    ) => {
      state.currentOrder = action.payload;
    },

    setCurrentOrderSupplier: (
      state,
      action: PayloadAction<any>
    ) => {
      state.currentOrderSupplier = action.payload;
    },

    setCurrentOrderHeaders: (
      state,
      action: PayloadAction<OrderHeaders>
    ) => {
      state.currentOrderHeaders = action.payload;
    },

    setCurrentOrderSectionHeaders: (
      state,
      action: PayloadAction<{
        sectionType: OrderSectionType;
        headers: OrderSectionHeader[];
      }>
    ) => {
      const {
        sectionType,
        headers,
      } = action.payload;

      state.currentOrderHeaders[sectionType] =
        headers;
    },

    clearCurrentOrderHeaders: (state) => {
      state.currentOrderHeaders =
        emptyOrderHeaders();
    },

    setShowPrice: (
      state,
      action: PayloadAction<any>
    ) => {
      state.showPrice = action.payload;
    },

    deletedOrder: (
      state,
      action: PayloadAction<any>
    ) => {
      state.isDeleted = action.payload;
    },

    setOrderShareStatus: (state, action) => {
      state.reqStatus = action.payload.req;
      state.orderId = action.payload.orderId;
    },
  },
});

export const {
  setCurrentOrder,
  setCurrentOrderSupplier,
  setCurrentOrderHeaders,
  setCurrentOrderSectionHeaders,
  clearCurrentOrderHeaders,
  setShowPrice,
  deletedOrder,
  setOrderShareStatus,
} = orderSlice.actions;

export default orderSlice.reducer;